import { Getters } from 'vuex-smart-module';
import WebSiteState from './state';

export default class WebSiteGetters extends Getters<WebSiteState> {
    
}